import { render, staticRenderFns } from "./Game4.vue?vue&type=template&id=3aee58c1&scoped=true&"
import script from "./Game4.vue?vue&type=script&lang=js&"
export * from "./Game4.vue?vue&type=script&lang=js&"
import style0 from "./Game4.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Game4.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Game4.vue?vue&type=style&index=2&id=3aee58c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee58c1",
  null
  
)

export default component.exports